import { render, staticRenderFns } from "./WsRequestExamCodeTypeForm.vue?vue&type=template&id=1848fef8"
import script from "./WsRequestExamCodeTypeForm.vue?vue&type=script&lang=js"
export * from "./WsRequestExamCodeTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports